import { NavLink } from 'react-router-dom';
import { cn } from '@/utils/cn';

const items = [
  { to: '/preventivi-e-conti', label: 'Documenti', end: true },
  { to: '/preventivi-e-conti/scadenziario', label: 'Scadenziario' },
  { to: '/preventivi-e-conti/listino', label: 'Listino' },
  { to: '/preventivi-e-conti/impostazioni', label: 'Impostazioni' },
];

export function BillingNav() {
  return (
    <div className="flex flex-wrap gap-2 border-b border-gray-200 pb-3 mb-6">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            cn(
              'rounded-md px-3 py-1.5 text-sm font-medium',
              isActive ? 'bg-blue-50 text-blue-700' : 'text-gray-600 hover:bg-gray-50'
            )
          }
        >
          {item.label}
        </NavLink>
      ))}
    </div>
  );
}
